import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';

export default function MultiSelector({
  inputValue,
  onInputChange,
  value,
  onChange,
  options,
  label,
  placeholder,
  id,
  getOptionLabel,
  disabled,
}) {
  return (
    <>
      <Autocomplete
        disabled={disabled}
        freeSolo
        value={value}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          onInputChange(newInputValue);
        }}
        multiple
        id={id}
        options={options}
        getOptionLabel={getOptionLabel}
        filterSelectedOptions
        renderInput={(params) => <TextField {...params} label={label} placeholder={placeholder} />}
      />
    </>
  );
}

MultiSelector.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

MultiSelector.defaultProps = {
  disabled: false,
};
